import { UploadLogoAPI } from "api/hotels";

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const uploadBrandLogoFromFile = async (file, hotelId) => {
  if (!file) throw new Error("No file provided");
  const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
  if (!allowedTypes.includes(file.type)) {
    throw new Error("Invalid file type - only PNG, JPEG, JPG allowed");
  }

  const maxSize = 5 * 1024 * 1024; // 5MB

  if (file.size > maxSize) {
    throw new Error("Image size must be 5 MB or less. Please upload a smaller image.");
  }

  const dataBase64 = await fileToBase64(file);

  const response = await UploadLogoAPI({
    id: hotelId,
    fileName: file.name,
    contentType: file.type,
    dataBase64,
  });

  return response;
};

export const prepareBrandLogoFromFile = async (file) => {
  if (!file) throw new Error("No file provided");

  const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
  if (!allowedTypes.includes(file.type)) {
    throw new Error("Invalid file type - only PNG, JPEG, JPG allowed");
  }

  const maxSize = 5 * 1024 * 1024; // 5MB
  if (file.size > maxSize) {
    throw new Error("Image size must be 5 MB or less. Please upload a smaller image.");
  }

  const dataBase64 = await fileToBase64(file);

  return {
    contentType: file.type,
    dataBase64,
  };
};
